import React, { useEffect, useState } from "react";
import about1 from "../assets/about1.png";
import about3 from "../assets/about3.png";
// import about4 from "../assets/about4.png";

import about1MB from "../assets/PNG/about1MB.png";
import about2MB from "../assets/PNG/about2MB.png";
import { NavLink } from "react-router-dom";
// import about3MB from "../assets/PNG/about3MB.png";

// import legal1 from "@/assets/PNG/Gibraltar-financial-services-commission-transparent 2.png";
// import legal2 from "@/assets/PNG/HM government gibraltar2 2.png";
// import legal3 from "@/assets/PNG/svg45962.png";
// import legal4 from "@/assets/PNG/6amld2 2.png";

const About: React.FC = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  // Funcția pentru detectarea dimensiunilor ecranului
  const checkIsMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  return (
    <div className="about">
      <div className="about__1 gap-36 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0 max-[899px]:flex-col">
        <div className="flex flex-col gap-8 justify-start pt-[2.5rem]">
          <div className="about__1__title">About us</div>
          <div className="about__1__text">
            Leonext is a modern financial services platform that offers seamless
            fiat-to-crypto and crypto-to-fiat conversion, multi-currency
            solutions, and business-friendly tools.
          </div>
          <div className="about__1__text">
            Leonext offers full spectrum support to businesses and HNI clients
            that want to convert cryptocurrencies to fiat currencies efficiently
            and quickly. Leonext’s cutting edge technology combined with a user
            friendly platform makes your crypto conversions easier than ever,
            ensuring you stay focused on your plans and goals.
          </div>
          <NavLink to="/login">
            {" "}
            <div className="solutions__1__container__button ps-6 flex justify-start">
              Get Started{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                  fill="#35BCAB"
                />
              </svg>
            </div>
          </NavLink>
        </div>
        {isMobile ? (
          <div className="w-full flex justify-end">
            <img className="w-[90%]" src={about1MB} alt="photo" />
          </div>
        ) : (
          <img className="mt-[8rem] h-[30rem]" src={about1} alt="photo" />
        )}
      </div>

      <div className="about__2 gap-24 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0 max-[899px]:flex-col-reverse">
        {isMobile ? (
          <div className="w-full flex">
            <img className="w-[90%]" src={about2MB} alt="photo" />
          </div>
        ) : (
          <img src={about3} alt="photo" />
        )}
        <div className="about__2__container">
          <div className="about__2__container__title">Short description</div>
          <div className="about__2__container__text">
            Our services help companies make international transactions more
            efficient, hedge currency risks, and always be one step ahead in the
            rapidly changing world of finance. Bringing together exceptional
            security, efficiency, and compliance, Leonext makes less complex
            financial operations that otherwise would be complicated and helps
            companies stay competitive in the digital world.
          </div>
          <NavLink to="/login">
            <div className="solutions__1__container__button ps-6 flex justify-start max-[899px]:m-auto max-[899px]:ps-0">
              Get Started{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                  fill="#35BCAB"
                />
              </svg>
            </div>
          </NavLink>
        </div>
      </div>

      <div></div>
    </div>
  );
};

export default About;
